const CLIENT_API_TOKEN_KEY = 'HEPHAESTUS_CLIENT_API_TOKEN';

export const saveClientAPIToken = (token: string) =>
  window.localStorage.setItem(CLIENT_API_TOKEN_KEY, token);
export const getClientAPIToken = () => window.localStorage.getItem(CLIENT_API_TOKEN_KEY);
export const clearClientAPIToken = () => window.localStorage.removeItem(CLIENT_API_TOKEN_KEY);
